export enum FontSize {
  SMALL = 'small',
  LARGE = 'large',
}
export enum Padding {
  SMALL = 'small',
  LARGE = 'large',
  NONE = 'none',
}
